import { UrlBasedUsageTracker } from '../../../lib/utils/tool-usage'
import { useUserService } from '../../../lib/hooks'
import { LocalStorageKey, getLocalStorageItem, setLocalStorageItem } from '../../../lib/utils/local-storage'
import { day } from '../../../lib/utils/time'

export const maxCountSubmitAnonymous = 1

export const useUpdateAIDetectorCountSubmit = (usageTracker?: UrlBasedUsageTracker): (() => void) => {
  const { isAnonymous } = useUserService().currentUser

  return () => {
    if (usageTracker) {
      usageTracker.incrementToolUsageState()
    } else if (isAnonymous) {
      const [expirationLocalStorageKey, expirationValue] = getExpirationTimestampFromLocalStorage()
      const [countLocalStorageKey, countValue] = getCountSubmitFromLocalStorage()

      const dateNow = Date.now()
      if (dateNow > expirationValue) {
        setLocalStorageItem(expirationLocalStorageKey, (dateNow + day * 1000).toString())
        setLocalStorageItem(countLocalStorageKey, '1')
      } else {
        setLocalStorageItem(countLocalStorageKey, (countValue + 1).toString())
      }
    }
  }
}

export const getExpirationTimestampFromLocalStorage = (): [LocalStorageKey, number] => {
  const localStorageKey = LocalStorageKey.expirationTimestampAIDetectorSubmitAnonymous
  const expirationFromLocalStorage = Number(getLocalStorageItem(localStorageKey))
  return [localStorageKey, isNaN(expirationFromLocalStorage) ? 0 : expirationFromLocalStorage]
}

export const getCountSubmitFromLocalStorage = (): [LocalStorageKey, number] => {
  const localStorageKey = LocalStorageKey.countAIDetectorSubmitAnonymous
  const countFromLocalStorage = Number(getLocalStorageItem(localStorageKey))
  return [localStorageKey, isNaN(countFromLocalStorage) ? 0 : countFromLocalStorage]
}
